module.exports = __webpack_public_path__ + "img/row_fit_gray.bbebd1be.png";